"use client"

import { useEffect, useState } from "react"
import { Col, Row, message } from "antd"
import TrainerCard from "./trainer_card"
import { restApi } from "../../../../apis"

const TrainerProfile = (props) => {
  const styles = {
    container: {
      display: "flex",
      width: "100%",
      flexDirection: "column",
    },
  }

  const { centerId, setCenterName, setLoading, ...rest } = props
  const [messageApi, contextHolder] = message.useMessage()
  const [isRead, setRead] = useState(false)
  const [data, setData] = useState({
    totalCount: 0,
    totalPages: 1,
    trainerList: [],
  })

  const getData = async (args) => {
    setLoading(true)
    const params = {
      pageNum: 1,
      orderBy: "account_name",
      sort: "ASC",
      centerId: centerId,
    }

    const response = await restApi
      .get(`/admin/trainer`, {
        params,
      })
      .then((v) => {
        return v.data.payload
      })

    setLoading(false)
    if (response) {
      setData({
        totalCount: response.totalCount,
        totalPages: response.totalPages,
        trainerList: response.trainerList,
      })
    }
  }

  // 트레이너 삭제 후 목록에서 제거하는 함수
  const removeTrainerFromList = (accountId) => {
    setData((prevData) => ({
      ...prevData,
      trainerList: prevData.trainerList.filter((trainer) => trainer.account_id !== accountId),
      totalCount: prevData.totalCount - 1,
    }))
  }

  // 트레이너 상태 변경 후 목록 업데이트하는 함수
  const updateTrainerInList = (accountId, updatedData) => {
    setData((prevData) => ({
      ...prevData,
      trainerList: prevData.trainerList.map((trainer) =>
        trainer.account_id === accountId ? { ...trainer, ...updatedData } : trainer,
      ),
    }))
  }

  useEffect(() => {
    getData()
  }, [])

  const columnSpan = 8 // 24/3ea = 8

  return (
    <div style={{ ...styles.container }}>
      <Row gutter={[16, 16]}>
        {data.trainerList.length ? (
          data.trainerList.map((item, idx) => {
            return (
              <Col span={columnSpan} key={item.account_id}>
                <TrainerCard
                  {...props}
                  data={item}
                  seq={item}
                  // 데이터 갱신 함수들을 props로 전달
                  onTrainerDeleted={removeTrainerFromList}
                  onTrainerUpdated={updateTrainerInList}
                  refreshData={getData}
                />
              </Col>
            )
          })
        ) : (
          <div>{`등록된 트레이너가 없습니다.`}</div>
        )}
      </Row>
      <div style={{ marginTop: 24 }} />
    </div>
  )
}

export default TrainerProfile
